@use '../../styles/variables.scss';

$fontSize: variables.$text-size--bigger;

@mixin activeFocusHasErrorDisabled {
  &:active {
    box-shadow: 0 0 0 1px #808080;
  }

  &:focus {
    outline: 0;
    box-shadow:
      0 0 0 1px #808080,
      0 0 0 4px #fff771;
  }

  &.has-error {
    border-color: #ed0000;

    &:active {
      box-shadow: 0 0 0 1px #ed0000;
    }

    &:focus {
      box-shadow:
        0 0 0 1px #ed0000,
        0 0 0 4px #fff771;
    }
  }

  &:disabled {
    background-color: #f2f2f2;
    border-color: #bfbfbf;
  }
}

.form {
  &-group {
    margin: 0;
    padding: 0;
    border: 0;

    &__legend {
      font-size: $fontSize;
      line-height: 1.625rem;
      margin-bottom: 1rem;
      font-weight: 400;
    }
  }

  &-element {
    position: relative;

    font-size: $fontSize;
    line-height: 1.5;
    font-weight: 400;
    margin-bottom: 1rem;

    &__label {
      font-weight: 600;
      display: block;
      line-height: normal;
      margin-bottom: 0.25rem;

      + .form-element__description {
        margin-top: -0.25rem;
      }

      &--required {
        margin-left: 0.25rem;
        color: #ed0000;
      }
    }

    &__description {
      margin-bottom: 0.5rem;
    }

    &__input {
      font-size: $fontSize;
      font-weight: 400;
      background-color: #fff;
      border-radius: 3px;
      border: 1px solid #808080;
      padding: 11px 12px;
      appearance: none;
      line-height: 1.375rem;
      max-width: 100%;
      width: 100%;
      box-sizing: border-box;
      transition: box-shadow 50ms ease-in-out;

      @include activeFocusHasErrorDisabled();
    }

    &__select {
      padding-right: 3rem;
      text-overflow: ellipsis;

      background-image: linear-gradient(45deg, transparent 50%, #808080 50%),
        linear-gradient(135deg, #808080 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
      background-position:
        calc(100% - 20px) calc(1em + 2px),
        calc(100% - 15px) calc(1em + 2px),
        calc(100% - 2.5rem) 0.5rem;
      background-size:
        5px 5px,
        5px 5px,
        1px 1.5em;
      background-repeat: no-repeat;
      transition: box-shadow 50ms ease-in-out;

      &:hover {
        cursor: pointer;
      }

      &:focus {
        background-image: linear-gradient(45deg, #808080 50%, transparent 50%),
          linear-gradient(135deg, transparent 50%, #808080 50%), linear-gradient(to right, #ccc, #ccc);
        background-position:
          calc(100% - 15px) 1em,
          calc(100% - 20px) 1em,
          calc(100% - 2.5rem) 0.5rem;
        background-size:
          5px 5px,
          5px 5px,
          1px 1.5em;
        background-repeat: no-repeat;
        border-color: #808080;
        outline: 0;
      }

      &.has-error {
        background-image: linear-gradient(45deg, transparent 50%, #ed0000 50%),
          linear-gradient(135deg, #ed0000 50%, transparent 50%), linear-gradient(to right, #ed0000, #ed0000);
        background-position:
          calc(100% - 20px) calc(1em + 2px),
          calc(100% - 15px) calc(1em + 2px),
          calc(100% - 2.5rem) 0.5rem;
        background-size:
          5px 5px,
          5px 5px,
          1px 1.5em;
        background-repeat: no-repeat;

        &:focus {
          background-image: linear-gradient(45deg, #ed0000 50%, transparent 50%),
            linear-gradient(135deg, transparent 50%, #ed0000 50%), linear-gradient(to right, #ed0000, #ed0000);
          background-position:
            calc(100% - 15px) 1em,
            calc(100% - 20px) 1em,
            calc(100% - 2.5em) 0.5em;
          background-size:
            5px 5px,
            5px 5px,
            1px 1.5em;
          background-repeat: no-repeat;
          border-color: #ed0000;
          outline: 0;
        }
      }
    }

    &__textarea {
      font-size: $fontSize;
      font-weight: 400;
      background-color: #fff;
      border-radius: 3px;
      border: 1px solid #808080;
      padding: 0.5rem;
      appearance: none;
      line-height: 1.375rem;
      max-width: 100%;
      width: 100%;
      box-sizing: border-box;
      resize: vertical;
      transition: box-shadow 50ms ease-in-out;

      &__counter {
        $counter-base: &;
        float: right;
        font-size: variables.$text-size--small;
        font-weight: variables.$font-weight--medium;
        margin-left: variables.$gutter--small;

        &--error {
          #{$counter-base}--current {
            color: variables.$color--red-400;
          }
        }

        &--disabled {
          color: variables.$color--black;
        }
      }

      @include activeFocusHasErrorDisabled();
    }
  }
}

.error-message {
  color: #ed0000;
  font-size: 16px;
  line-height: normal;
  display: flex;
  align-items: flex-start;
  font-style: italic;
  margin-top: 0.25rem;
}
